import {axios, API, SendRequest} from '@/imports-files/pages/clients/my-preferences';

export class MyPreferences extends SendRequest
{
  
  async addPreferences(params, quick_setup) 
  { 
    let body = {'user': params.users}
    if(quick_setup) body.quick_setup = quick_setup
    try 
    {
      const result = await axios.post(API.client.my_preferences.ADD_MY_PREFERENCES_URL,
          body,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } 
    catch (error) 
    {
      return error;
    }
  }

  async getPreferences(params) 
  {
    try {
        const result = await axios.get(API.client.my_preferences.GET_MY_PREFERENCES_URL,
        {
          params:params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
        return result;
    } catch (error) {
      return error;
    }
  }

  async updateTimeZone(params) 
  { 
    try 
    {
      const result = await axios.post(API.client.my_preferences.UPDATE_TIME_ZONE,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } 
    catch (error) 
    {
      return error;
    }
  }
}
